/**
 * @fileoverview added by tsickle
 * Generated from: models/worker-metrics.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/** @enum {string} */
var FulfilmentStates = {
    Low: "Low",
    Ok: "Okay",
    Good: "Good",
    None: "None",
};
export { FulfilmentStates };
/**
 * @record
 */
export function WorkerMetrics() { }
if (false) {
    /**
     * The worker's reliability streak.
     * @type {?}
     */
    WorkerMetrics.prototype.daysReliable;
    /**
     * The total amount the worker has been fined.
     * @type {?}
     */
    WorkerMetrics.prototype.finesPounds;
    /**
     * The worker's fulfilment rate as a decimal from '0.00' to '1.00'.
     * @type {?}
     */
    WorkerMetrics.prototype.fulfilmentPercentage;
    /**
     * The fulfilment state of good, ok, low
     * @type {?}
     */
    WorkerMetrics.prototype.fulfilmentState;
    /**
     * True if the worker has self-assigned a lot of visits outside their normal working areas.
     * @type {?}
     */
    WorkerMetrics.prototype.hasSignificantVisitsOutsideOfArea;
    /**
     * The worker's average rating as a decimal from '1.00' to '5.00'.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingAverage;
    /**
     * The number of ratings the worker has received.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingCount;
    /**
     * The number of 5-star ratings the worker has received.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingFiveStarCount;
    /**
     * The number of 4-star ratings the worker has received.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingFourStarCount;
    /**
     * True if the worker's average rating is above the minimum threshold we've set in the backend.
     * "Above average" is a misnomer. A better name might be `ratingAverageIsAboveMinimumThreshold`.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingIsAboveAverage;
    /**
     * True if the worker's average rating is above an upper threshold we've set in the backend.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingIsAboveTargetAverage;
    /**
     * True if the worker's average rating is above a threshold we've set for trialling workers.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingIsAboveTriallingTargetAverage;
    /**
     * The number of low ratings the worker has received.
     * @type {?}
     */
    WorkerMetrics.prototype.ratingLowCount;
    /**
     * The worker's reliability rate as a decimal from '0.00' to '1.00'.
     * @type {?}
     */
    WorkerMetrics.prototype.reliability;
    /**
     * The threshold corresponding to `ratingIsAboveTargetAverage`.
     * @type {?}
     */
    WorkerMetrics.prototype.targetAverageRating;
    /**
     * The number of actioned absence periods bookings.
     * @type {?}
     */
    WorkerMetrics.prototype.timeOffCount;
    /**
     * The total amount the worker has been tipped.
     * @type {?}
     */
    WorkerMetrics.prototype.tipTotalPounds;
    /**
     * The total number of visits the worker could have done.
     * Includes finished ("fulfilled") and affected ("unfulfilled") visits
     * @type {?}
     */
    WorkerMetrics.prototype.totalVisits;
    /**
     * The threshold corresponding to `ratingIsAboveTriallingTargetAverage`.
     * @type {?}
     */
    WorkerMetrics.prototype.triallingTargetAverageRating;
    /**
     * The number of visits a trialling worker must finish before they can be confirmed.
     * @type {?}
     */
    WorkerMetrics.prototype.triallingTargetVisitCount;
    /**
     * The percentage of hours utilized for cleaning by the worker's schedule
     * @type {?|undefined}
     */
    WorkerMetrics.prototype.utilisationPercentage;
    /**
     * The number of visits that were finished ("fulfilled").
     * @type {?}
     */
    WorkerMetrics.prototype.visitCount;
    /**
     * The number of visits the worker has affected at late notice through time off.
     * @type {?}
     */
    WorkerMetrics.prototype.visitsAffectedLate;
    /**
     * The number of visits the worker has affected at short notice through time off.
     * @type {?}
     */
    WorkerMetrics.prototype.visitsAffectedShort;
    /**
     * The number of visits the worker has self-assigned outside their normal working areas.
     * @type {?}
     */
    WorkerMetrics.prototype.visitsOutsideNormalArea;
}
/** @type {?} */
export var workerMetrics = model.extend({
    modelName: 'workerMetrics'
});
